// extracted by mini-css-extract-plugin
module.exports = {"backToTopWrapper":"jo","arrowUp":"jp","backToTopLink":"jq"};